import React from 'react'
import { Link } from 'gatsby'
import Layout from '../../components/layout'
import Carousel from '../../components/carousel'

const data = require('../../xml/yellology.json');

export const query = graphql`
  query {
    allMarkdownRemark(filter: {frontmatter: {type: {eq: "yellology"}, id: {eq: "biography"}}}) {
      edges {
        node {
          id
          frontmatter {
            title
          }
          heading: headings(depth: h1) {
            value
          }
          html
        }
      }
    }
  }
`

const Yellology = (props) => {
  console.log('data', props.data)

  const article2 = props.data.allMarkdownRemark.edges[0].node

  const article = data.root.biography;
  const images = article.images.image.map(x => ({
    url: x['$t'],
    caption: x.caption
  }))

  const menu = (
    <p>
      <b>BIOGRAPHY</b>
      <span>|</span>
      <Link to={'/yellology/borisblank/'}>BORIS BLANK</Link>
      <span>|</span>
      <Link to={'/yellology/dietermeier/'}>DIETER MEIER</Link>
    </p>
  );

  return (
    <Layout>
      <div className="pagesubmenu mobile-only">{menu}</div>
      <div className="lightboxcolumn">
        <Carousel images={images} />
      </div>
      <div className="narrowcontentcolumn withmenu">
        <header>
          <div className="close">
            <Link to={'/empty/'} alt="Close">Close<img src="/img/x.gif" /></Link>
          </div>
          <h3>
            YELLO<i>logy</i>
          </h3>
        </header>
        <div className="narrowcontentmenu desktop-only">{menu}</div>
        <div className="narrowcontent">
          <div className="inner">
            <h2>BIOGRAPHY<br/>&#8211;</h2>
            <div dangerouslySetInnerHTML={{ __html: article2.html }}></div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Yellology
